import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasUser from './aidas-user';
import AidasUserDetail from './aidas-user-detail';
import AidasUserUpdate from './aidas-user-update';
import AidasUserDeleteDialog from './aidas-user-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasUserUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasUserUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasUserDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasUser} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasUserDeleteDialog} />
  </>
);

export default Routes;
